'use client';

import React from 'react';

import { UserContext } from '@/context';
import type { UserModelType } from '@/models/users';

type Props = {
  user?: UserModelType;
  children: React.ReactNode;
};

const UserProvider: React.FC<Props> = ({ user, children }) => {
  return (
    <UserContext.Provider value={{ me: user }}>{children}</UserContext.Provider>
  );
};

export default UserProvider;
